import {FuseRouteItemType} from '@/@fuse/utils/FuseUtils';
import {AUTH_ROLES} from '@/app/auth';

import AddKidPage from './AddKidPage';
import AddKidWarningPage from './pages/AddKidWarning/AddKidWarningPage';
import ContactInfoPage from './pages/ContactInfo/ContactInfoPage';
import CreatingKidPage from './pages/CreatingKid/CreatingKidPage';
import KidCreatedPage from './pages/KidCreated/KidCreatedPage';
import PersonalInfoPage from './pages/PersonalInfo/PersonalInfoPage';
import SummaryInfoPage from './pages/SummaryInfo/SummaryInfoPage';

const AddKidRoute: FuseRouteItemType = {
  path: 'add-kid',
  element: <AddKidPage />,
  auth: AUTH_ROLES.parent, // []
  children: [
    {
      path: 'personal-info',
      element: <PersonalInfoPage />,
    },
    {
      path: 'contact-info',
      element: <ContactInfoPage />,
    },
    {
      path: 'summary',
      element: <SummaryInfoPage />,
    },
    {
      path: 'creating',
      element: <CreatingKidPage />,
    },
    {
      path: 'created',
      element: <KidCreatedPage />,
    },
    {
      path: 'warning',
      element: <AddKidWarningPage />,
    },
  ],
};

export default AddKidRoute;
